import React from "react";
import "./Modal.css";
import { X } from "lucide-react";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="Modal--Overlay" onClick={onClose}>
      <div className="Modal--Content" onClick={(e) => e.stopPropagation()}>
        <button className="Modal--CloseButton" onClick={onClose}>
          <X size={24} />
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
